import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 03FA1C8F-8808-4293-A12A-7D9B7F8890D4
 * name transfer-left
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transfer-left.svg
 * tags
 * - Arrow 
 */
export const TransferLeftIcon = createSvgIcon(<><path d="M21,16H19V8H21V16M17,16H15V8H17V16M13,16H11V8H13V16M9,5V19L2,12L9,5Z" /></>, 'TransferLeftIcon');
export default TransferLeftIcon